import React from 'react';
import clsx from 'clsx';
import { Box, Typography } from '@mui/material';
import { useTimeout } from '@fuse/hooks';

interface FuseLoadingProps {
	delay?: number;
}

function FuseLoading({ delay = 0 }: FuseLoadingProps) {
	const [showLoading, setShowLoading] = React.useState(!delay);

	useTimeout(() => {
		setShowLoading(true);
	}, delay);

	return (
		<div className={clsx('flex flex-1 flex-col items-center justify-center p-24', !showLoading && 'hidden')}>
			<Typography className="-mb-16 text-13 font-medium sm:text-20" color="text.secondary">
				Loading
			</Typography>
			<Box
				id="spinner"
				sx={{
					'& > div': {
						backgroundColor: 'palette.secondary.main'
					}
				}}
			>
				<div className="bounce1" />
				<div className="bounce2" />
				<div className="bounce3" />
			</Box>
		</div>
	);
}

export default FuseLoading;
